import { API_URL } from '../../../app-config/constants';
import type { UserListDto } from '../../../types/UserDtos';
import { get } from '../request';

const RESOURCE = `${API_URL}/users`;

getAllActiveHrs.operation = 'READ';
export function getAllActiveHrs(includeAssistants = false) {
    return get<UserListDto[]>(`${RESOURCE}/hrs?include-assistants=${includeAssistants}`);
}
